import { render, staticRenderFns } from "./Nota.vue?vue&type=template&id=775ae548&scoped=true"
import script from "./Nota.vue?vue&type=script&lang=ts"
export * from "./Nota.vue?vue&type=script&lang=ts"
import style0 from "./Nota.vue?vue&type=style&index=0&id=775ae548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ae548",
  null
  
)

export default component.exports